import $ from 'jquery';
import BaseLineup from 'services/sports/default/base-lineup';
import {round} from 'helpers/number-helper';

export default class LineupSinglegame extends BaseLineup {
    getValidationRules({defaultValue = {}, ...rest}) {
        return {
            exposureMinPropNames: ['exposureMin', 'captain_exposureMin'],
        };
    }

    sumPlayersProperty({incomingValues: {players, prop}}) {
        let result = 0;
        players.map((player) => {
            result += Number(player.getCapPropValue(prop));
        });

        return result;
    }

    sumPlayersRoundedProperty({incomingValues: {players, prop, decimalPlacesCount = 0}}) {
        return players.reduce((propSum, player) => {
            const propValue = Number(player.getCapPropValue(prop));

            return propSum + round(propValue, decimalPlacesCount);
        }, 0);
    }

    setPlayersByColumns({incomingValues: {team}}) {
        let captain = null;
        let flex = [];
        team.map((player) => {
            if (player.getIsCaptain()) {
                captain = {...player, positionInLineup: 'MVP - 1.5x Points'};
            } else {
                flex.push({...player, positionInLineup: 'UTIL'});
            }
        });
        return $.merge([captain], flex);
    }

    recalculateLineupsUsedPlayers({incomingValues: {lineups}}) {
        return this.exec('recalculateLineupsUsedPlayers_ShowDown', {lineups});
    }
}
